import iconHeartBubble from '@/assets/images/icons/icon-heart-bubble.png';
import { EcItemType, EcItemTypeType } from '../../types';
import styles from './EcItemTypeLabel.module.scss';

function EcItemTypeLabel({
  ecItemType,
  hasMessage = false,
  size = 'default',
}: {
  ecItemType?: EcItemTypeType;
  hasMessage?: boolean;
  size?: 'default' | 'large';
}) {
  return (
    <div className={`${styles.componentStyle} ${styles[`${size}ComponentStyle`]}`}>
      {hasMessage ? (
        <>
          <div className={`${styles.iconContainer} ${styles[`${size}IconContainer`]}`}>
            <img src={iconHeartBubble.src} alt='' className={styles[`${size}Icon`]}></img>
          </div>
          <div className={`${styles.hasMessageText} ${styles[`${size}HasMessageText`]}`}>メッセージ付き</div>
        </>
      ) : (
        <></>
      )}
      {ecItemType && (
        <div className={`${styles.typeText} ${styles[`${size}TypeText`]}`}>{EcItemType[ecItemType].text}</div>
      )}
    </div>
  );
}

export default EcItemTypeLabel;
